import React, { useState, useEffect } from "react";
import { useTheme } from "../components/ThemeContext";
import {
  Form,
  Button,
  Row,
  Col,
  Dropdown,
  DropdownButton,
  Modal,
} from "react-bootstrap";
import "../App.css";
import NavMenu from "../components/NavMenu";
import axios from "axios";
import { IoMdEye } from "react-icons/io";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import TextareaAutosize from "react-textarea-autosize";
import { HiOutlineDuplicate } from "react-icons/hi";
import { MdDeleteOutline } from "react-icons/md";
import { IoArrowBackSharp } from "react-icons/io5";

function AppraisalManagement() {
  // const [step, setStep] = useState(1);
  const [selectedValue, setSelectedValue] = useState("Select role");
  const [roles, setRoles] = useState([]);
  const [template, setTemplate] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { isDark } = useTheme();

  const [factors, setFactors] = useState([
    { factor: "", description: "", rating: "5" },
    { factor: "", description: "", rating: "5" },
    { factor: "", description: "", rating: "5" },
  ]);

  // const [performances, setPerformances] = useState([
  //   { description: "", score: "", rating: "" },
  // ]);

  const handleSelectRole = (eventKey) => {
    const selectedRole = roles.find(
      (role) => String(role.role_id) === String(eventKey)
    );

    setSelectedValue(selectedRole?.roles || "Select Role");
  };

  const handleClose = () => setShowModal(false);
  const handleShow = async () => {
    await fetchTemplate();
    setShowModal(true);
  };

  const handleEdit = (item) => {
    console.log("View/Edit clicked for:", item);
    navigate(`/edit-appraisal/${item.role_id}`);
  };

  useEffect(() => {
    const fetchRoles = async () => {
      try {
         const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

        const response = await axios.get(
          process.env.REACT_APP_API + `/getRoles`,
           {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          setRoles(response.data.data);
        } else {
          console.error("Error fetching roles:", response.data.message);
        }
      } catch (err) {
        console.error("Failed to fetch tags:", err);
      }
    };

    fetchRoles();
  }, []);

  const fetchTemplate = async () => {
    try {
       const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

      const response = await axios.get(
        process.env.REACT_APP_API + `/getTemplate`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      if (response.data.success) {
        setTemplate(response.data.data);
      } else {
        console.error("Error fetching the Template:", response.data.message);
      }
    } catch (err) {
      console.error("Failed to fetch Template", err);
    }
  };

  const addFactor = () => {
    setFactors([...factors, { factor: "", description: "", rating: "5" }]);
  };

  // const addPerformance = () => {
  //   setPerformances([
  //     ...performances,
  //     { description: "", score: "", rating: "" },
  //   ]);
  // };

  const handleFactorChange = (index, field, value) => {
    const updated = [...factors];
    updated[index][field] = value;
    setFactors(updated);
  };

  // const handlePerformanceChange = (index, field, value) => {
  //   const updated = [...performances];
  //   updated[index][field] = value;
  //   setPerformances(updated);
  // };

  const saveTemplate = async () => {
    const selectedRole = roles.find((r) => r.roles === selectedValue);
    if (!selectedRole) {
      alert("Please select a valid role.");
      return;
    }

    const role_id = selectedRole.role_id;

    if (factors.length === 0) {
      alert("Please add at least one factor and one performance.");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

      const response = await axios.post(
        `${process.env.REACT_APP_API}/saveTemplate`,
        {
          role_id,
          factors,
          // performances,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );

      if (response.data.success) {
        alert("Template saved successfully!");
        // setStep(1);
        setSelectedValue("Select role");
        setFactors([
          { factor: "", description: "", rating: "5" },
          { factor: "", description: "", rating: "5" },
          { factor: "", description: "", rating: "5" },
        ]);
        // setPerformances([
        //   { description: "", score: "", rating: "" },
        //   { description: "", score: "", rating: "" },
        //   { description: "", score: "", rating: "" },
        // ]);
      } else {
        alert("Failed to save template. Please try again.");
      }
    } catch (error) {
      console.error("Error saving template:", error);
      alert("Server error. Please try again later.");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <NavMenu />
      <div className={`p-4 ${isDark ? "text-light" : "text-dark"}`}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="header-title mb-0">
            <Button
              variant={isDark ? "outline-dark" : "outline-light"}
              size="sm"
              onClick={handleBack}
              style={{
                fontSize: "0.9rem",
                color: "#B31E8D",
                border: isDark ? "1px solid #202020" : "1px solid #EAECF0",
              }}
            >
              <IoArrowBackSharp
                style={{
                  marginRight: "5px",
                  color: isDark ? "#fff" : "#B31E8D",
                }}
                size={20}
              />
            </Button>{" "}
            Appraisal Management{" "}
            <span className={isDark ? "text-secondary" : "text-muted"}>
              (Create Template)
            </span>
          </h5>

          <div className="d-flex align-items-center">
            <p className="mb-0 me-2">Template For:</p>
            <DropdownButton
              title={selectedValue || "Select tags"}
              onSelect={handleSelectRole}
              variant={isDark ? "dark" : "outline-dark"}
            >
              {Array.isArray(roles) && roles.length > 0 ? (
                roles.map((role) => (
                  <Dropdown.Item key={role.role_id} eventKey={role.role_id}>
                    {role.roles}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No Roles available</Dropdown.Item>
              )}
            </DropdownButton>
            &nbsp;
            <Button
              variant="outline-light"
              size="sm"
              style={{
                border: "solid #B31E8D 2px",
                color: "#B31E8D",
                backgroundColor: isDark ? "#2c2c2c" : "transparent",
              }}
              onClick={handleShow}
            >
              <IoMdEye size={20} /> &nbsp; View Template
            </Button>
          </div>
        </div>

        {/* <div className="stepper mb-4">
          {[1, 2, 3].map((num) => (
            <React.Fragment key={num}>
              <div
                className={`step ${step === num ? "active" : ""}`}
                onClick={() => setStep(num)}
                style={{ cursor: "pointer" }}
              >
                {num}
              </div>
              {num < 3 && <div className="line" />}
            </React.Fragment>
          ))}
        </div> */}

        {/* {step === 1 && ( */}
        <>
          <p className="fw-semibold">Part I: COMPETENCIES</p>
          <Row>
            <Col md={3}>
              <p>Factor</p>
            </Col>
            <Col md={6}>
              <p>Description</p>
            </Col>
            <Col md={3}>
              <p>Rating</p>
            </Col>
          </Row>
          {factors.map((factor, idx) => (
            <Row key={idx} className="mb-3">
              <Col md={3}>
                <TextareaAutosize
                  className="form-control"
                  placeholder={`Factor #${idx + 1}`}
                  value={factor.factor}
                  onChange={(e) =>
                    handleFactorChange(idx, "factor", e.target.value)
                  }
                  minRows={2}
                  maxRows={10}
                  style={{
                    backgroundColor: isDark ? "#282828" : "#fff",
                    color: isDark ? "#fff" : "#000",
                    borderColor: isDark ? "#444" : "#ced4da",
                  }}
                />
              </Col>
              <Col md={6}>
                <TextareaAutosize
                  className="form-control"
                  placeholder="Description"
                  value={factor.description}
                  onChange={(e) =>
                    handleFactorChange(idx, "description", e.target.value)
                  }
                  minRows={2}
                  maxRows={10}
                  style={{
                    backgroundColor: isDark ? "#282828" : "#fff",
                    color: isDark ? "#fff" : "#000",
                    borderColor: isDark ? "#444" : "#ced4da",
                  }}
                />
              </Col>
              <Col md={3}>
                <Form.Select
                  className={
                    isDark ? "bg-dark text-light border-secondary" : ""
                  }
                  value={factor.rating}
                  onChange={(e) =>
                    handleFactorChange(idx, "rating", e.target.value)
                  }
                >
                  <option>Rating</option>
                  <option>5</option>
                  <option>4</option>
                </Form.Select>
              </Col>
            </Row>
          ))}
          <div className="d-flex gap-3 mt-4">
            <Button
              variant="outline-light"
              size="sm"
              style={{
                background: "#B31E8D",
                color: "white",
                borderColor: isDark ? "#fff" : "transparent",
              }}
              onClick={addFactor}
            >
              Add Factor
            </Button>
            {/* <Button
                variant="outline-light"
                onClick={() => setStep(2)}
                style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
              >
                Next Page
              </Button> */}
          </div>
          <div className="d-flex justify-content-end mt-4">
            <Button
              variant="outline-light"
              size="sm"
              style={{
                background: "#B31E8D",
                width: "150px",
                height: "50px",
                color: "white",
                borderColor: isDark ? "#fff" : "transparent",
              }}
              onClick={saveTemplate}
            >
              Save Template
            </Button>
          </div>
        </>
        {/* )} */}

        {/* {step === 2 && (
          <>
            <p className="fw-semibold">
              Part II: SPECIFIC PERFORMANCE OBJECTIVES
            </p>
            <Row>
              <Col md={7}>
                <p>Description of Work Targets and Actual Results Attained</p>
              </Col>
              <Col md={2}>
                <p>Weight</p>
              </Col>
              <Col md={3}>
                <p>Rating</p>
              </Col>
            </Row>
            {performances.map((perf, idx) => (
              <Row key={idx} className="mb-3">
                <Col md={7}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder="Key Objectives"
                    value={perf.description}
                    onChange={(e) =>
                      handlePerformanceChange(
                        idx,
                        "description",
                        e.target.value
                      )
                    }
                    minRows={2}
                    maxRows={10}
                  />
                </Col>
                <Col md={2}>
                  <Form.Select
                    value={perf.score}
                    onChange={(e) =>
                      handlePerformanceChange(idx, "score", e.target.value)
                    }
                  >
                    <option>Weight</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </Form.Select>
                </Col>
                <Col md={3}>
                  <Form.Select
                    value={perf.rating}
                    onChange={(e) =>
                      handlePerformanceChange(idx, "rating", e.target.value)
                    }
                  >
                    <option>Rating</option>
                    <option>5</option>
                    <option>4</option>
                  </Form.Select>
                </Col>
              </Row>
            ))}
            <div className="d-flex gap-3 mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={addPerformance}
              >
                Add New Performance
              </Button>
              <Button
                variant="outline-light"
                onClick={() => setStep(3)}
                style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
              >
                Next Page
              </Button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <p className="fw-semibold">Part III: OVERALL ASSESSMENT</p>
            <p className="fw-semibold">Summary of Ratings</p>
            <p>Overall Rating For Part I & Part II</p>

            <Row className="mb-4">
              <Col md={3}>
                {[
                  "EXCELLENT",
                  "VERY GOOD",
                  "GOOD",
                  "SATISFACTORY",
                  "BELOW AVERAGE",
                  "POOR",
                ].map((label, i) => (
                  <p key={i} className="fw-semibold">
                    {label}
                  </p>
                ))}
              </Col>
              <Col md={2}>
                {[
                  "4.5 to 5.0",
                  "4.0 to 4.49",
                  "3.5 to 3.99",
                  "3.0 to 3.49",
                  "2.5 to 2.99",
                  "< 2.5",
                ].map((score, i) => (
                  <p key={i} className="fw-semibold">
                    {score}
                  </p>
                ))}
              </Col>
              <Col md={7}>
                <p className="text-secondary small">
                  Excellent performance, well exceeded expectations. For
                  recruiters who exceed 120% of quota.
                </p>
                <p className="text-secondary small">
                  Very good performance and consistently exceed expectations.
                  For recruiters who exceed 100% -119% of quota.
                </p>
                <p className="text-secondary small">
                  Good performance and exceed expectations in many areas. For
                  recruiters who exceed 85% - 100% of quota.
                </p>
                <p className="text-secondary small">
                  Satisfactory performance, meet basic expectations and need
                  some supervision. For recruiters who achieved between 70-84%
                  of quota.
                </p>
                <p className="text-secondary small">
                  Below average performance. Needs supervision in their work.
                  Warrant P-I-P if performance remains below average for 2
                  consecutive quarters. Recruiters who meet 50% - 69% of quota.
                </p>
                <p className="text-secondary small">
                  Poor performance. Need improvement and a lot of supervision in
                  all work areas. Warrant P-I-P. Recruiters who achieved less
                  than 50% of quota for more than 2 consecutive quarters.
                </p>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={saveTemplate}
              >
                Save Template
              </Button>
            </div>
          </>
        )} */}

        <Modal show={showModal} onHide={handleClose} centered size="lg">
          <Modal.Header
            closeButton
            className={isDark ? "bg-dark text-light" : ""}
          >
            <Modal.Title>Appraisal Template Details</Modal.Title>
          </Modal.Header>

          <Modal.Body className={isDark ? "bg-dark text-light" : ""}>
            <table
              className={`table table-bordered text-center ${isDark ? "table-dark" : ""}`}
            >
              <thead
                className={
                  isDark ? "bg-secondary text-light" : "table-light text-center"
                }
              >
                <tr>
                  <th style={{ width: "5%" }}>No</th>
                  <th style={{ width: "40%" }}>Roles</th>
                  <th style={{ width: "20%" }}>Created Date</th>
                  <th style={{ width: "30%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {template && template.length > 0 ? (
                  template.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.roles}</td>
                      <td>
                        {item.created_at && item.created_at !== "0000-00-00"
                          ? moment(item.created_at).format("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center gap-2">
                          <Button
                            size="sm"
                            style={{
                              backgroundColor: "#B31E8D",
                              border: "none",
                              color: "white",
                            }}
                            onClick={() => handleEdit(item)}
                          >
                            View & Edit
                          </Button>
                          <Button
                            variant="outline-light"
                            size="sm"
                            style={{
                              color: "#B31E8D",
                              borderColor: "#B31E8D",
                              backgroundColor: isDark
                                ? "#2c2c2c"
                                : "transparent",
                            }}
                          >
                            <HiOutlineDuplicate size={20} />
                          </Button>
                          <Button
                            variant="outline-light"
                            size="sm"
                            style={{
                              color: "#B31E8D",
                              borderColor: "#B31E8D",
                              backgroundColor: isDark
                                ? "#2c2c2c"
                                : "transparent",
                            }}
                          >
                            <MdDeleteOutline size={20} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4">No templates available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </Modal.Body>

          <Modal.Footer className={isDark ? "bg-dark text-light" : ""}>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default AppraisalManagement;
